<p>modal-request-details-base works!</p>
